const questionFields = ["key", "prompt", "kind", "parameter", "showWhenKey", "showWhenValue"];
const lookupFields = ["lookupPath", "lookupQueryKey", "lookupQueryValue", "lookupResultsPath", "lookupIdField", "lookupLabelField"];

export function missingQuestionField(requested = [], saved = []) {
  if (!Array.isArray(saved) || requested.length !== saved.length) return "question count";
  for (let index = 0; index < requested.length; index += 1) {
    const current = requested[index];
    const stored = saved[index] || {};
    const fields = ["lookup", "range"].includes(current.kind) ? [...questionFields, ...lookupFields] : questionFields;
    const missing = fields.find(field => String(current[field] ?? "") !== String(stored[field] ?? ""));
    if (missing) return `question ${index + 1} (${missing})`;
    if ((current.required !== false) !== (stored.required !== false)) return `question ${index + 1} (required)`;
    if (current.kind === "choice" && JSON.stringify(current.choices || []) !== JSON.stringify(stored.choices || [])) return `question ${index + 1} (choices)`;
  }
  return "";
}
